<template>
  <div>
    <a-modal
      v-model="isShow"
      centered
      :mask-closable="false"
      :title="$props.packageName+'销售趋势'"
    >
      <template slot="footer">
        <a-button key="back" type="primary" @click="handleCancel">
          关闭
        </a-button>
      </template>
      <div class="custom-padding-bottom-10px custom-flex custom-flex-row custom-justify-between">
        <div>
          <a-range-picker
            @change="handleChange"
            :value="value"
            v-if="timeType === 'day'"
            style="width: 250px"
          />
        </div>
        <div>
          <span>
            <a-radio-group
              v-model="timeType"
              @change="handleChangeTimeType"
              button-style="solid"
            >
              <a-radio-button value="day">
                日
              </a-radio-button>
              <a-radio-button value="month">
                月
              </a-radio-button>
              <a-radio-button value="year">
                年
              </a-radio-button>
            </a-radio-group>
          </span>
        </div>

      </div>
      <package-trend-chart :data="{time_type: timeType, date_begin: startTime, date_end: endTime, package_id: $props.packageId}" />

    </a-modal>
  </div>
</template>

<script>
import { formatYearMonthDay } from '@/utils/time'
import PackageTrendChart from '@/views/package_product_data/packages/PackageTrendChart'

export default {
  name: 'PackageSingleTrendChart',
  components: {
    // eslint-disable-next-line vue/no-unused-components
    PackageTrendChart
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    packageId: {
      type: Number,
      required: true
    },
    packageName: {
      type: String,
      required: true
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  data() {
    return {
      chart: null,
      tagStatistics: [],
      timeType: 'day',
      loading: true,
      isShowChart: true,
      datePickerValue: undefined,
      startTime: '',
      endTime: '',
      value: []
    }
  },
  methods: {
    handleChangeTimeType(e) {
      this.$nextTick()
      this.timeType = e.target.value
    },

    handleChange(value) {
      this.value = value
      if (this.timeType === 'day' && value !== '') {
        this.startTime = formatYearMonthDay(value[0])
        this.endTime = formatYearMonthDay(value[1])
      } else {
        this.startTime = ''
        this.endTime = ''
      }
    },

    handleCancel() {
      this.isShow = false
    }
  }
}
</script>
<style lang="less" scoped>
.title {
  color: @primary-color;
  margin-right: 10px;
}
</style>
